import React from 'react';

const LayoutWrapper = ({ children }) => {
  return <div className="layout">{children}</div>;
};

export default LayoutWrapper;
